import React from 'react';
import {FaAddressBook} from "react-icons/fa";

const ContactsCellRenderer = (params) => {
    const {value, data, contactsRender} = params;

    return (
        <>
            <div className={"text-blue-700 w-full h-full place-content-center justify-items-center text-2xl"} onClick={() => contactsRender(data, value)}>
                <FaAddressBook />
            </div>

        </>
    );
};

export default ContactsCellRenderer;